import { useState } from 'react';
import { CampoControlado, validarCampos, type DefCampo } from '../../componentes/formulario';
import { useValidacaoLocal } from '../../componentes/validacao-local';
import { ErroRequisicao, mensagemDeErro } from '../../nucleo/api';

const LARGURAS = { inteira: 'sm:col-span-6', meia: 'sm:col-span-3', terco: 'sm:col-span-2' };

/** Envio com erro geral e erros por campo vindos da API (422 do domínio ou do Zod). */
export function useEnvio() {
  const [erros, setErros] = useState<Record<string, string>>({});
  const [geral, setGeral] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  useValidacaoLocal(erros, geral);
  /** Obrigatórios no cliente, antes de chamar a API; `extras` são erros já calculados pelo formulário (ex.: alvos). */
  function validar(campos: DefCampo[], valores: Record<string, unknown>, extras: Record<string, string> = {}): boolean {
    const locais = { ...validarCampos(campos, valores), ...extras };
    setErros(locais);
    setGeral(null);
    return Object.keys(locais).length === 0;
  }
  async function enviar(fn: () => Promise<unknown>): Promise<boolean> {
    setErros({});
    setGeral(null);
    setEnviando(true);
    try {
      await fn();
      return true;
    } catch (e) {
      if (e instanceof ErroRequisicao) {
        const porCampo = e.porCampo();
        const geral = mensagemDeErro(e);
        setErros(porCampo);
        // Mensagem repetida no campo não precisa aparecer de novo no topo.
        setGeral(Object.values(porCampo).includes(geral) ? null : geral);
      } else setGeral(mensagemDeErro(e));
      return false;
    } finally {
      setEnviando(false);
    }
  }
  return { erros, geral, enviando, enviar, validar };
}

/**
 * Campos de um formulário cujos valores moram no componente pai (para o pai reagir a eles, por exemplo
 * mostrar um campo conforme a escolha de outro). Mesma grade e mesmos controles do Formulario do núcleo.
 */
export function CamposLocais({ campos, valores, aoMudar, erros, rotulosAtuais }: { campos: DefCampo[]; valores: Record<string, unknown>; aoMudar: (nome: string, v: unknown) => void; erros?: Record<string, string>; rotulosAtuais?: Record<string, string> }) {
  return (
    <>
      {campos
        .filter((c) => !c.visivel || c.visivel(valores))
        .map((c) => (
          <div key={c.nome} className={LARGURAS[c.largura ?? 'inteira']}>
            <CampoControlado def={c} valor={valores[c.nome]} erro={erros?.[c.nome]} rotuloAtual={rotulosAtuais?.[c.nome]} aoMudar={(v) => aoMudar(c.nome, v)} />
          </div>
        ))}
    </>
  );
}

export function ErroGeral({ texto }: { texto: string | null }) {
  if (!texto) return null;
  return (
    <p role="alert" className="rounded-lg border border-perigo px-3 py-2 text-sm text-perigo col-span-full">
      {texto}
    </p>
  );
}
